export enum facebookConversionTypes {
  FACEBOOK_PURCHASE_EVENT = 'FACEBOOK_PURCHASE_EVENT',
  FACEBOOK_ADD_CART_EVENT = 'FACEBOOK_ADD_CART_EVENT',
  FACEBOOK_VIEW_CONTENT_EVENT = 'FACEBOOK_VIEW_CONTENT_EVENT',
  FACEBOOK_COMPLETE_REGISTER_EVENT = 'FACEBOOK_COMPLETE_REGISTER_EVENT',
  FACEBOOK_FIND_LOCATION_EVENT = 'FACEBOOK_FIND_LOCATION_EVENT',
  FACEBOOK_INITIATE_CHECKOUT_EVENT = 'FACEBOOK_INITIATE_CHECKOUT_EVENT',

  FACEBOOK_EVENT_REQUEST = 'FACEBOOK_EVENT_REQUEST',
  FACEBOOK_EVENT_SUCCESS = 'FACEBOOK_EVENT_SUCCESS',
  FACEBOOK_EVENT_FAILURE = 'FACEBOOK_EVENT_FAILURE',
}
